<p>dynamic-slide-toggle works!</p>
